import { useLayoutEffect, useState, type RefObject } from "react";

/**
 * Elemanın kendi genişliği (px). Pencereye değil kaba göre ölçeklenen
 * bileşenler için: aynı bileşen dock'ta da tam sayfada da doğru dizilsin.
 * İlk ölçüm gelene kadar 0 döner; çağıran bir varsayılan uygular.
 */
export function useElementWidth(ref: RefObject<HTMLElement | null>): number {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setWidth(el.clientWidth);
    const ro = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);

  return width;
}
